import React, { useReducer } from 'react';

import Company from 'schema/company';

interface UserContextProviderProps {
  children?: React.ReactNode;
}

interface UserState {
  isOwner: boolean | null;
  token: string | null;
  company: Company | null;
}

interface UserActionSignIn {
  type: 'SIGNIN';
  payload: UserState;
}

interface UserActionSignOut {
  type: 'SIGNOUT';
}

const initialUserState: UserState = localStorage.sansanTechUserState
  ? JSON.parse(localStorage.sansanTechUserState)
  : {
      isOwner: null,
      token: null,
      company: null,
    };

const userStateReducer = (
  userState: UserState,
  userAction: UserActionSignIn | UserActionSignOut
) => {
  switch (userAction.type) {
    case 'SIGNIN':
      localStorage.setItem(
        'sansanTechUserState',
        JSON.stringify(userAction.payload)
      );
      return { ...userState, ...userAction.payload };
    case 'SIGNOUT':
      localStorage.removeItem('sansanTechUserState');
      return {
        ...userState,
        isOwner: null,
        token: null,
        company: null,
      };
  }
};

const UserContext = React.createContext<{
  userState: UserState;
  userDispatch: React.Dispatch<UserActionSignIn | UserActionSignOut> | null;
}>({
  userState: initialUserState,
  userDispatch: null,
});

const UserContextProvider: React.FC<UserContextProviderProps> = ({
  children,
}) => {
  const [userState, userDispatch] = useReducer(
    userStateReducer,
    initialUserState
  );

  return (
    <UserContext.Provider value={{ userState, userDispatch }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
export { UserContext };
